import {theme} from "../../../../../utils";

export type ResourceCardType = {
    image?: any; // Image is imported
    title: string;
    filePath: string; // For PDF
};

export const resourceCardStyles = {
    cardBody: {
        display:"flex",
        flexDirection: "column",
        maxWidth:"536px",
        boxShadow: "0px 6px 8px 0px #00000029",
        textAlign: "left",
    },
    image: {
        maxWidth: '386px',
    },
    download: {
        container : {
            display: "flex",
            pb: "20px"
        },
        ctaTitle: {
            ...theme.typography.montseratH1,
            fontSize: "20.28px",
            fontStyle: "normal",
            color: theme.palette.primary.main,
            lineHeight: '26.4px',
            letterSpacing: '0.45px',
        },
    }
}